import { render, staticRenderFns } from "./transaction-details.vue?vue&type=template&id=42801200&scoped=true"
import script from "./transaction-details.vue?vue&type=script&setup=true&lang=js"
export * from "./transaction-details.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42801200",
  null
  
)

export default component.exports